import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  svg {
    width: 24px;
    height: 24px;
  }

  p {
    font-size: ${props => props.theme.rem(16)};
    line-height: ${props => props.theme.rem(20)};
    color: ${props => props.theme.readMoreInline.color};

    ${props =>
      props.showMore &&
      `
        display: -webkit-box;
        -webkit-line-clamp: ${props.maxLines};
        -webkit-box-orient: vertical;
        overflow: hidden;
    `}
  }

  button {
    width: fit-content;
    text-decoration: underline;
    padding: 0;

    svg {
      path {
        fill: ${props => props.theme.readMoreInline.iconColor};
      }
    }

    &:hover {
      background: transparent;
    }
  }
`;
